import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/settings/wedding')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/w/$workspaceSlug', params, replace: true })
  },
})
